export enum PaymentResult {
  Pending = "Pending",
  Success = "Success",
  Declined = "Declined",
  Error = "Error",
}
